import { render, staticRenderFns } from "./VoiceAISetting.vue?vue&type=template&id=359369ba&scoped=true"
import script from "./VoiceAISetting.vue?vue&type=script&lang=js"
export * from "./VoiceAISetting.vue?vue&type=script&lang=js"
import style0 from "./VoiceAISetting.vue?vue&type=style&index=0&id=359369ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359369ba",
  null
  
)

export default component.exports